import React, { useState } from 'react';
import { FaPhoneAlt, FaFacebookF, FaInstagram } from 'react-icons/fa';
import qrCode from '../assets/location-qr.png';
import { API_BASE_URL } from '../config';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: ''
  });

  const [submitting, setSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setStatusMessage('');

    try {
      const res = await fetch(`${API_BASE_URL}/inquiries`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await res.json();

      if (res.ok) {
        setStatusMessage('✅ Inquiry submitted successfully!');
        setFormData({
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          message: ''
        });
      } else {
        setStatusMessage(`❌ Error: ${result.error || 'Something went wrong'}`);
      }
    } catch (err) {
      console.error('Submission error:', err);
      setStatusMessage('❌ Failed to submit inquiry. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-us">
      <h2>Contact Us</h2>

      <div className="map-container">
        <iframe
          title="SP Rao Technologies Location"
          src="https://www.google.com/maps?q=17.44531422587002,78.44679269571162&z=17&output=embed"
          width="100%"
          height="300"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>

      <div className="contact-content">
        <div className="contact-left">
          <h3>Address</h3>
          <p>SP Rao Technologies, 2nd Floor, Tech Plaza, Hyderabad, TG, India</p>

          <h3>Phone</h3>
          <p><FaPhoneAlt /> +91 90005 61116</p>

          <h3>Email</h3>
          <p>info@spraotech.in</p>

          <h3>Scan to Navigate</h3>
          <a
            href="https://maps.app.goo.gl/9vuoy68iYE7LdXyBA"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={qrCode}
              alt="QR Code to SP Rao Technologies Location"
              style={{ width: '150px', marginTop: '10px' }}
            />
          </a>
        </div>

        <div className="contact-right">
          <h3>Inquiry Form</h3>
          <form onSubmit={handleSubmit}>

              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                required
              />

            <input
              type="tel"
              name="phone"
              placeholder="Phone Number"
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email ID"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Write your message here..."
              rows="5"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
            <button type="submit" disabled={submitting}>
              {submitting ? 'Sending...' : 'Send Inquiry'}
            </button>
            {statusMessage && <p className="status-message">{statusMessage}</p>}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;